(function($) {
    'use strict';

    $(".tag-search .close").on("click", function(e) {
        console.log('tst');
        var _this   =   $(this),
            _parent =   _this.parent(),
            _id     =   _parent.data("code"),
            _ref    =   _parent.data("collapse"),
            _form   =   _parent.parents("form").first();
        
        if ($(_this).hasClass('keywords-keyword')){
            $('.keywords-keyword').val('');
        }

        if ($(_this).hasClass('keywords-location')){
            $('.keywords-location').val('');
        }

        if( $("#"+_ref).length > 0 ) {
            $("#"+_ref).find("input:checkbox[value='"+_id+"']").prop({"checked":false}).uniform().change();
            if (_id === "keyword"){
                $('.keywords-keyword').val('')
            }
            if (_id === "location"){
                $('.keywords-location').val('')
            }
            _form.trigger("submit");
        }
        e.preventDefault();
        return false;
    });

    $(".tag-search.geoip .close").on("click", function(e) {
        var _this   =   $(this),
            _parent =   _this.parent(),
            _id     =   _parent.data("code"),
            _ref    =   _parent.data("collapse"),
            _form   =   _parent.parents("form").first();
        document.cookie = "geoip"+'=; Max-Age=-99999999;';

        if( $("#"+_ref).length > 0 ) {
            $("#"+_ref).find("input:checkbox[value='"+_id+"']").prop({"checked":false}).uniform().change();
            _form.trigger("submit");
        }
        e.preventDefault();
        return false;
    });
//
})(jQuery);